<template>
  <div class="web-settings">
    <header-mobile-page v-if="$mq === 'mobile'"
                        :label="child.name" />

    <website-settings :mode-id="child.default_mode_id"
                      :child-id="child.id" />
  </div>
</template>

<script>
  import WebsiteSettings from '@/components/Child/ChildWebsiteSettings/WebsiteSettings'
  import HeaderMobilePage from '@/components/Header/HeaderMobilePage'

  export default {
    components: {
      WebsiteSettings,
      HeaderMobilePage
    },

    props: {
      childId: {
        type: String,
        required: true
      }
    },

    computed: {
      child() {
        return this.getChildById(this.childId)
      },

      ...mapGetters('children', {
        getChildById: 'getById'
      })
    }
  }
</script>

<style lang="scss" scoped>
  .web-settings {
    width: 100%;
    height: auto;

    padding: 0 20px 10px 20px;
  }
</style>